import { FC } from 'react';
import styled from 'styled-components/macro';
import Hero from './hero';
import BecomeAnAgent from './BecomeAnAgent';
import EasySteps from './easySteps';
import FAQ from './faq';
import JoinUs from './JoinUs';
import Contact from './contact';
import WhyDotPay from './whyDotPay';

interface LandingPage {}

export type navLinksType = Array<{ label: string; link: string }>

const Home: FC<LandingPage> = () => {
    return (
      <HomePageStyling>
        <Hero />
        <BecomeAnAgent />
        <WhyDotPay />
        <EasySteps />
        <div style={{ background: "url('/assets/images/line2.svg')", backgroundSize: 'cover' }}>
          <FAQ />
          <Contact />
          <JoinUs />
        </div>
      </HomePageStyling>
    );
};
const HomePageStyling = styled.div`
  width: 100%;
`;
export default Home;
